<h2 matDialogTitle>Enter Resolution Comment</h2>
<mat-dialog-content>
    @if(selectedError(); as error) {
        <p class="mb-2 text-break">Integration error: {{error.logMessage}}</p>
    }
    
    @if(selectedStatus(); as status) {
        <p class="mb-2 text-break">New Status: {{status.statusName}}</p>    
    }
    
    <div class="mt-3">
        <span>
            <h6 class="fw-medium mb-2">Resolution Comment:</h6>
        </span>

        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Max 200 characters</mat-label>
            <input matInput 
                maxlength="200" 
                [value]="resolutionComment()"
                (input)="updateComment($event)"
                placeholder="Enter resolution comment" 
                title="Resolution Comment">
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton 
        (click)="updateError()"
        [disabled]="isUpdating() || !canUpdate()">
        @if(isUpdating()) {
            Updating...
        } @else {
            Update Status
        }
    </button>
    <button matButton (click)="cancelUpdate()">Close</button>
</mat-dialog-actions>